import { Component, Injector, OnInit, AfterContentInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableFunctionsService } from '@services/table/table-functions.service';
import { RouteDataService } from '@services/route-data/route-data.service';
import { UsersService } from '@services/entity/users.service';
import { BlackboxService } from '@services/entity/blackbox.service';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { CustomersService } from '@services/entity/customers.service';
import { Blackbox } from "@models/blackbox";
import { Subscription } from 'rxjs';
import '@angular/localize/init';
import { ComponentBase } from '../../abstracts/component-base';
import { ToastService } from "@services/toast/toast.service";
import { plainToClass } from "class-transformer";
import { UserDto } from '../../dto/userDto';
import { AuthenticationService } from '../../services/authentication/authentication.service';


@Component({
  selector: 'app-energy',
  templateUrl: './energy.component.html',
  styleUrls: ['./energy.component.scss']
})
export class EnergyComponent extends ComponentBase implements OnInit {

  public className = 'EnergyComponent';

  public activeTab = 'energy-monitor';

  public primaryKey;
  public hasBlackbox: boolean;
  public hasBidi: boolean;
  public blackbox: Blackbox[];

  public title = '';

  public routerSubscription: Subscription;

  public isProduction: boolean = false;
  public isSupporter: boolean = false;
  public customerId: string;
  public customer: UserDto;


  public activeComponentClassName: string;

  links = [
    {
      title: $localize`:@@EvaluationTitel1:Energymonitor`, route: 'energy-monitor'
    },
    {
      title: $localize`:@@EvaluationTitel2:Bidi-Laden`, route: 'bidi-charging'
    },
  ];

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public tableFunctions: TableFunctionsService,
    private routeDataService: RouteDataService,
    public chargingStationsService: ChargingStationsService,
    public authenticationService: AuthenticationService,
    public customersService: CustomersService,
    public blackboxService: BlackboxService,
    public toastService: ToastService,
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.customerId = localStorage.getItem("customerId")
    this.blackboxService
      .getByCustomerId(parseInt(this.customerId))
      .subscribe(result => {
        this.blackbox = plainToClass(Blackbox, result);
        console.log(result)
        if (result.length>=1) {
          this.hasBlackbox = true;
        } else {
          this.hasBlackbox = false
        }
      });
    this.chargingStationsService
      .checkChargingStationsOfCurrentCustomerHasBidi()
      .subscribe(res => {
        if (res) {
          this.hasBidi = true;
        } else {
          this.hasBidi = false;
        }
      });
    //console.log(this.blackbox);

  }

  public onRouterOutletActivate(event: any) {
    this.activeComponentClassName = event.className;
    this.determineActiveTab()
  }

  determineActiveTab() {
    for (let link of this.links) {
      if (this.router.url.includes(link.route)) {
        this.activeTab = link.route;
      }
    }
  }
}
